var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"80":1,"200":1,"482":1,"653":1,"796":1,"1040":1,"1041":1,"1267":1,"1404":1,"1616":1,"1869":1,"1901":1,"1937":1,"1998":1,"2032":1,"2118":1,"2353":1,"2398":1,"2409":1,"2432":1,"2556":1,"2583":1,"2774":1,"2840":1,"2927":1,"2931":1,"3004":1,"3047":1,"3151":1,"3287":1,"3432":1,"3455":1,"3479":1,"3536":1,"3622":1,"3974":1,"3984":1,"4059":1,"4088":1,"4208":1,"4253":1,"4949":1,"5056":1,"5175":1,"5262":1,"5285":1,"5446":1,"5608":1,"5615":1,"5708":1,"5876":1,"5996":1,"6061":1,"6208":1,"6258":1,"6272":1,"6461":1,"6497":1,"6627":1,"6666":1,"6784":1,"6800":1,"6910":1,"6924":1,"6937":1,"7339":1,"7394":1,"7495":1,"7576":1,"7620":1,"7721":1,"7735":1,"7835":1,"8306":1,"8374":1,"8403":1,"8552":1,"8716":1,"9026":1,"9237":1,"9253":1,"9583":1,"9857":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr